import React from "react";
import { StyleSheet, Text, View } from "react-native";

interface MedicalItemProps {
  item: {
    id: string;
    berat: number;
    tinggi: number;
    riwayatPenyakit: string;
    penyakit: string;
    alergiMakanan: string;
    alergiObat: string;
    activeInsuranceTab: string;
    insurance: string;
  };
}

const Medical = ({ item }: MedicalItemProps) => {
  return (
    <View style={styles.homeMedical}>
      <Text style={styles.homeMedicalText}>
        {item.tinggi}cm / {item.berat}kg
      </Text>
      <Text style={styles.homeMedicalText}>
        Riwayat Penyakit :{" "}
        {item.riwayatPenyakit === "Lain-lain"
          ? item.penyakit
          : item.riwayatPenyakit}
      </Text>
      <Text style={styles.homeMedicalText}>
        Alergi Makanan : {item.alergiMakanan}
      </Text>
      <Text style={styles.homeMedicalText}>
        Alergi Obat : {item.alergiObat}
      </Text>
      <Text style={styles.homeMedicalText}>
        Asuransi :{" "}
        {item.activeInsuranceTab === "Lain-lain"
          ? item.insurance
          : item.activeInsuranceTab}
      </Text>
    </View>
  );
};

export default Medical;

const styles = StyleSheet.create({
  homeMedical: {
    borderWidth: 3,
    borderColor: "#FF2828",
    borderRadius: 15,
    paddingHorizontal: "5vw",
    paddingVertical: "1vh",
    marginBottom: 10,
  },
  homeMedicalText: {
    fontSize: 16,
    fontWeight: "400",
  },
});
